/*=========================================================================================
  File Name: module-auth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-config-state';
import mutations from './module-config-mutations';
import actions from './module-config-actions';
import getters from './module-config-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
};
